import { InfoReviews } from './InfoReviews'
import { PageTitle } from './PageTitle'
import { PriceInfo } from './PriceInfo'
import { RewardPoints } from './RewardPoints'
import { ShippingInfo } from './ShippingInfo'
import { SpecialPromo } from './SpecialPromo'
import { StockStatus } from './StockStatus'
import { TbiCard } from './TbiCard'
import { Separator } from '../../../../Theme'

function ProductCode({ sku }: { sku: string }) {
  return (
    <p className="font-main-font text-sm xl:text-lg text-second-btn-bg mb-5 text-center md:text-start xl:text-start">
      Cod produs: {sku}
    </p>
  )
}

/** The product info column: title block, price, reward points, shipping and financing. */
export function ProductInfoSections({ sku }: { sku: string }) {
  return (
    <div>
      <div className="bg-cards-bg p-5 flex flex-col justify-start">
        <PageTitle />
        <SpecialPromo />
        <InfoReviews />
        <ProductCode sku={sku} />
        <StockStatus />
      </div>

      <PriceInfo />
      <Separator className="my-3 xl:my-5" />
      <RewardPoints />
      <ShippingInfo />
      <TbiCard />
    </div>
  )
}
